// CORE-496 — pure geometry + layering for the onboarding spotlight. Split out of
// OnboardingTourOverlay so the math is unit-testable (no RN/DOM).
//
// The step card used to live in this layer; it now lives in Agapella's pop-up,
// so what's left here is the hole and the stacking order between the two
// surfaces.

export interface Rect {
  top: number;
  left: number;
  width: number;
  height: number;
}

export const SPOTLIGHT_PAD = 8;

/** The dim layer sits above the page… */
export const TOUR_OVERLAY_Z_INDEX = 9999;
/** …and Agapella's pop-up above the dim layer, so she is never dimmed. */
export const WIDGET_TOUR_Z_INDEX = 10000;

/** The highlighted "hole": the anchor rect padded and clamped to the viewport top-left. */
export function spotlightHole(rect: Rect, pad = SPOTLIGHT_PAD): Rect {
  return {
    top: Math.max(rect.top - pad, 0),
    left: Math.max(rect.left - pad, 0),
    width: rect.width + pad * 2,
    height: rect.height + pad * 2,
  };
}
